import { FaLinkedin, FaXTwitter, FaEnvelope } from 'react-icons/fa6';

export const Founder = () => {
    const founderLinkedIn = "https://www.linkedin.com/in/tanmay-shah-ca/"; // Replace with Jane's actual LinkedIn profile URL
    const founderX = "https://x.com/tanmayshahh"; // Replace with Jane's actual X profile URL
    const founderGmail = "mailto:tanmay@evergreenpartners.in"; // Replace with Jane's actual Gmail address

    return (
        <section id="founder" className="py-20 h-auto md:h-screen">
            <div className="max-w-7xl mx-auto px-4">
                <div className="mb-10 mt-20 text-center">
                  <span className="text-xl font-bold mr-1">Meet</span>            
                  <span className="text-xl font-bold text-green-600">Our </span>
                  <span className="text-xl font-bold mr-1">Founder</span>            

                </div>
                <div className="grid md:grid-cols-2 md:gap-16 items-center px-4">
                    <div>
                        <img src="/founder-tanmay.jpeg" alt="Founder" className="rounded-full shadow-lg mx-auto size-36 md:size-96" />
                    </div>
                    <div className="mt-10 md:m-0">
                        <div className="text-2xl text-center md:text-left md:text-5xl font-bold mb-2 text-green-500">CA Tanmay Shah</div>
                        <div className="text-xs text-center md:text-left md:text-xl font-normal mb-4 text-green-800"><i>(Ex-JPMorgan Investment Banking)</i></div>
                        <p className="text-sm md:text-lg text-gray-600 mb-6 text-center md:text-left">
                        At Evergreen Growth Partners, we believe in creating a legacy, not just wealth. With a strong foundation as a Chartered Accountant and rich experience in the investment banking division at global banks, I founded this firm with a vision to redefine financial advisory for individuals and entrepreneurs alike.
                        </p>

                        <div className="flex space-x-4 mt-4 md:items-start items-center justify-center md:justify-start">
                            <a href={founderLinkedIn} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-green-600">
                                <FaLinkedin size={32} />
                            </a>
                            <a href={founderX} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-green-600">
                                <FaXTwitter size={32} />
                            </a>
                            <a href={founderGmail} className="text-gray-500 hover:text-green-600">
                                <FaEnvelope size={32} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
